export default __webpack_public_path__ + "static/media/req_status_circle..2f237c74.svg";